/* * @Author: ligai  */
import Vue from '@/app'
import response from '../../../../utils/response'
import {projectInfo} from '../../../../utils'
import apis from '../api'
const project = projectInfo.query()
const vm = new Vue()

export default {
  currency: {
    methods: {
      async getCurrencyList () {
        const {type, url} = project === 'pur' ? apis.currencyQueryList : apis.currencyList
        const data = await response(vm.$http(type, url), {authError: false})
        if (data.isOk) {
          return {
            currencyList: data.content || []
          }
        }
      },
      async getEnableCurrencyList () {
        const {type, url} =  apis.currencyList
        let params = {status: project === 'pur' ? 'ENABLE' : '1'} // 启用状态的币种
        const data = await response(vm.$http(type, url, params), {authError: false})
        if (data.isOk) {
          let list = data.content || []
          if (project === 'pur') {
            list.forEach(item => {
              item.currencyCode = item.code
            })
          }
          return {
            currencyList: list
          }
        }
      },
      async getCurrencyBase () {
        const {type, url} = apis.currencyBase
        const data = await response(vm.$http(type, url), {authError: false})
        if (data.isOk) {
          return {
            baseCurrencyCode: data.content || ''
          }
        }
      }
    }
  },
  'getThousandthPercentile': {
    methods: {
      // 批量获取规则
      async getSystemRulesKey () {
        const api = apis.getListByRuleKey
        const params = [
          // 金额，单价是否开启千分位
          'amount_unit_price_thousands_config',
          // 数量是否开启千分位
          'number_thousands_config'
        ]
        const { code, content } = await response(vm.$http(api.type, api.url, params), {authError: false})
        if (code === 'success') {
          return content
        }
      }
    }
  }
}
